import { Textarea } from "@arcadeai/design-system/components/ui/atoms/textarea";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@arcadeai/design-system/rhf";
import type { UseFormReturn } from "react-hook-form";
import type { AuthProvider } from "@/app/oauth/types";

type Props = {
  form: UseFormReturn<AuthProvider>;
  canUpdate: boolean;
};

export const DescriptionField = ({ form, canUpdate }: Props) => (
  <FormField
    control={form.control}
    name="description"
    render={({ field }) => (
      <FormItem>
        <FormLabel>Description</FormLabel>
        <FormControl>
          <Textarea
            className="min-h-16"
            placeholder="A short description of this OAuth provider."
            {...field}
            disabled={!canUpdate}
          />
        </FormControl>
        <FormMessage />
      </FormItem>
    )}
  />
);
